/*
 * @Auther: 罗耀祖
 * @Date: 2022-02-09 16:12:57
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-08-24 09:51:41
 * @name: 我的售后工单详情页面对象
 * @Description: 我的售后工单详情页面对象
 * @FilePath: \project\src\views\index\afterSale\waitApproveDeal\waitApproveDeal.view.js
 * @Author: desktop
 */
import router from "@/router";
import issueService from "@/module/issue/issue.service";
import { afterSale_detail_btn } from "@/config/afterSale.config.js";
import { getEventBus } from "@/config/eventBus.config.js";
import { origin_fee } from "@/config/issue.config.js";
import { debounceation } from "@/utils/decorator";
import { Message, MessageBox, Loading } from "element-ui";
const waitApproveDealView = class {
  constructor(ctx) {
    this.ctx = ctx; //vue上下文
    this.issueService = new issueService();
    this.musical = '';
    this.create_time = ''; //创建时间(经销商发起时间)
    this.agency = {}; //经销商信息
    this.agency_receive_address = {}; //退补货地址
    this.run_process = []; //流程
    this.piano_model = ''; //型号
    this.piano_no = ''; //琴号
    this.piano_color = ''; //颜色
    this.piano_images = []; //图片
    this.package_images = []; //破损外包装图
    this.express_images = []; //物流单据图
    this.other_question_des = ''; //其他-问题描述
    this.other_question_urls = []; //其他-问题图片
    this.positions = []; //问题部位
    this.plan = {}; //处理信息
    this.quality_verify = {}; //品质审批意见信息
    this.is_confirm_fee = 0; //是否已提交费用 0 否 1是
    this.fee = JSON.parse(JSON.stringify(origin_fee)); //费用
    this.afterSale_detail_btn = JSON.parse(JSON.stringify(afterSale_detail_btn)); // 按钮
    this.evaluate_status = 0; //评价状态
    this.content = ''; //内容
    this.process_type = ''; //当前步骤类型
    this.pay_user = 1; //费用收取对象
    this.need_pay = 1; //是否需要费用
    this.edit_fee_allow = false; //可否修改费用
    this.payment_info = null; //支付费用
    this.piano_fail_type = ''; //琴号错误类型
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 获取详情
   */
  getDetail() {
    let req = {
      issue_id: this.ctx.$route.query.issue_id,
      run_id: this.ctx.$route.query.run_id,
      run_process_id: this.ctx.$route.query.run_process_id,
    };
    this.issueService.getVeifyQuality(req).then(res => {
      const obj = res.data;
      this.create_time = obj.create_time;
      this.agency = obj.agency || {};
      this.agency_receive_address = obj.agency_receive_address || {};
      this.musical = obj.musical;
      this.piano_model = obj.piano_model ?? '';
      this.piano_no = obj.piano_no ?? '';
      this.piano_color = obj.piano_color ?? '';
      this.piano_images = obj.piano_images ? obj.piano_images.split(',') : [];
      this.package_images = obj.package_images ? obj.package_images.split(',') : [];
      this.express_images = obj.express_images ? obj.express_images.split(',') : [];
      this.other_question_des = obj.other_question_des ? obj.other_question_des : '';
      this.other_question_urls = obj.other_question_urls ? obj.other_question_urls.split(',') : [];
      this.positions = obj.positions ? JSON.parse(obj.positions) : [];
      this.plan = obj.plan || {};
      this.quality_verify = obj?.quality_verify ?? {};
      this.is_confirm_fee = obj.is_confirm_fee || 0;
      this.need_pay = obj.plan?.need_pay ?? 1;
      this.pay_user = obj.plan?.pay_user ?? 1;
      this.edit_fee_allow = obj.edit_fee_allow ?? false;
      if (obj.fee) {
        let fee = JSON.parse(JSON.stringify(origin_fee));
        fee[fee.findIndex(x => x.key === "shell_fee")].value = Number(obj.fee?.parts_fee?.["shell_fee"] ?? '');
        fee[fee.findIndex(x => x.key === "code_fee")].value = Number(obj.fee?.parts_fee?.["code_fee"] ?? '');
        fee[fee.findIndex(x => x.key === "prellmechanik_fee")].value = Number(obj.fee?.parts_fee?.["prellmechanik_fee"] ?? '');
        fee[fee.findIndex(x => x.key === "keyboard_fee")].value = Number(obj.fee?.parts_fee?.["keyboard_fee"] ?? '');
        fee[fee.findIndex(x => x.key === "hardware")].value = Number(obj.fee?.parts_fee?.["hardware"] ?? '');
        fee[fee.findIndex(x => x.key === "hammer")].value = Number(obj.fee?.parts_fee?.["hammer"] ?? '');
        fee[fee.findIndex(x => x.key === "other")].value = Number(obj.fee?.parts_fee?.["other_fee"] ?? '');
        fee[fee.findIndex(x => x.key === "parts_remark")].value = obj.fee?.parts_fee?.["parts_remark"] ?? '';
        fee[fee.findIndex(x => x.key === "by_the_piece_fee")].value = Number(obj.fee?.salary?.["by_the_piece_fee"] ?? '');
        fee[fee.findIndex(x => x.key === "hourly_wages")].value = Number(obj.fee?.salary?.["hourly_wages"] ?? '');
        fee[fee.findIndex(x => x.key === "oil_paint")].value = Number(obj.fee?.salary?.["oil_paint"] ?? '');
        fee[fee.findIndex(x => x.key === "salary_remark")].value = obj.fee?.salary?.["salary_remark"] ?? '';
        fee[fee.findIndex(x => x.key === "amount_returned_by_customer")].value = Number(obj.fee?.trans_port?.["amount_returned_by_customer"] ?? '');
        fee[fee.findIndex(x => x.key === "return_customer_amount")].value = Number(obj.fee?.trans_port?.["return_customer_amount"] ?? '');
        fee[fee.findIndex(x => x.key === "transport_remark")].value = obj.fee?.trans_port?.["transport_remark"] ?? '';
        fee[fee.findIndex(x => x.key === "management_expenses")].value = Number(obj.fee?.others?.["management_expenses"] ?? '');
        fee[fee.findIndex(x => x.key === "tax")].value = Number(obj.fee?.others?.["tax"] ?? '');
        fee[fee.findIndex(x => x.key === "others_fee")].value = Number(obj.fee?.others?.["others_fee"] ?? '');
        fee[fee.findIndex(x => x.key === "others_remark")].value = obj.fee?.others?.["remark"] ?? '';
        this.fee = fee;
      } else {
        this.fee = [];
      }
      this.run_process = this.issueService.dealRunProcess(obj.run_process);
      this.evaluate_status = obj.evaluate_status;
      this.content = obj.content;
      this.process_type = obj.process_type;
      this.payment_info = obj.payment_info?.[0] ?? null;
      if (
        obj.musical !== "其它" &&
        this.ctx.$route.query.run_act.split("|").includes("fangan") && 
        Number(this.ctx.$route.query.run_status) === 0
      ) {
        this.getPianoInfo();
      }
    })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 获取琴号信息
   */
  getPianoInfo() {
    let loadingInstance = Loading.service({ text: '获取琴号数据...' });
    this.issueService.getPianoInfo({
      issue_id: this.ctx.$route.query.issue_id,
      piano_no: this.piano_no,
    }).then(res => {
      if (res.data.length === 0) {
        this.piano_fail_type = "error";
      } else {
        let model = res.data?.[0]?.model ?? "";
        let color = res.data?.[0]?.color_id?.[1] ?? "";
        if (
          model !== this.piano_model ||
          color !== this.piano_color
        ) {
          this.piano_fail_type = "warning";
        } else {
          this.piano_fail_type = "";
        }
        this.piano_model = model;
        this.piano_color = color;
      }
    }).catch((err) => {
      this.piano_fail_type = "error";
    }).finally(() => {
      loadingInstance.close();
    })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 按钮点击触发
   * @param {Object} item 点击的按钮数据
   * @param {Object} query 页面参数
   */
  @debounceation(300)
  btnClickHandler(item, query) {
    // if(this.piano_fail_type === 'error') {
    //   Message.error('有待处理事项!');
    //   return;
    // }
    let param = { issue_id: query.issue_id, run_process_id: query.run_process_id, run_id: query.run_id, ...item }
    // 已评价
    if (Number(this.evaluate_status) === 1) {
      this.ctx.$refs.dialogEvaluate.open(this.content);
    }
    if (Number(query.run_status) === 0) {
      if (String(item.value) === '-1') {
        this.ctx.$refs.dialogApproveNormal.open(param);
      } else {
        switch (query.run_act) {
          case 'fangan':
            router.push({ path: '/index/afterSale/waitApproveSignDealScheme', query })
            break;
          case 'xuyingxiaozhuren':
            this.ctx.$refs.dialogApproveXuyingxiaozhuren.open(param);
            break;
          case 'yingxiaozhurenshenpi':
            this.ctx.$refs.dialogApproveNormal.open(param);
            break;
          case 'pinzhisp':
            this.ctx.$refs.dialogApprovePinzhisp.open(param);
            break;
          case 'dingjia':
            router.push({ path: '/index/afterSale/waitApproveSignAmount', query })
            break;
          case 'cwdingjia':
            MessageBox.confirm('确认定价?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            }).then(() => {
              const fee = this.fee;
              let params = {};
              fee.forEach((x) => {
                params[x.key] = x.value;
              });
              params.need_pay = this.need_pay;
              params.pay_user = this.pay_user;
              const req = {
                issue_id: this.ctx.$route.query?.issue_id ?? "",
                run_process_id: this.ctx.$route.query?.run_process_id ?? "",
                ...params,
              };
              this.issueService.issueFee(req).then((res) => {
                this.ctx.$EventBus.$emit(getEventBus("我的售后列表发生变更"));
                this.ctx.$router.go(-1);
              });
            }).catch(() => { });
            break;
          case 'xufuzongshenpi':
            this.ctx.$refs.dialogApproveXufuzongshenpi.open(param);
            break;
          case 'sale_second_boss':
            this.ctx.$refs.dialogApproveFuzongshenpi.open(param);
            break;
          case '':
            this.ctx.$refs.dialogApproveNormal.open(param);
            break;
        }
      }
    }
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 审核结束
   */
  approveFinish() {
    this.ctx.$EventBus.$emit(getEventBus("我的售后列表发生变更"));
    this.ctx.$EventBus.$emit(getEventBus("待审批列表发生变更"));
    this.ctx.$router.go(-1);
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 跳转修改页面
   */
  @debounceation(300)
  toEdit() {
    this.ctx.$router.push({ path: '/index/afterSale/updateDealScheme', query: this.ctx.$route.query })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 更新费用
   * @param {Object} obj 费用信息
   */
  editFee(obj) {
    console.log(obj)
    const fee = obj.fee;
    let params = {};
    fee.forEach((x) => {
      params[x.key] = x.value;
    });
    params.pay_user = this.pay_user;
    const req = {
      issue_id: this.ctx.$route.query?.issue_id ?? "",
      run_process_id: this.ctx.$route.query?.run_process_id ?? "",
      ...params,
    };
    this.issueService.editFee(req).then(res => {
      this.getDetail();
    })
  }
}

export default waitApproveDealView;